// A file dropped on the dashboard's "drop to start" bar, handed to the Studio
// on the next mount. Kept in a module variable (not router state) so the File
// object survives the navigation intact.
let pending: File | null = null;

export function setPendingUpload(f: File): void {
  pending = f;
}
export function takePendingUpload(): File | null {
  const f = pending;
  pending = null;
  return f;
}
